import { getProfileSuccess } from "../../store/actions/get-profile"

export const handleLogout = (dispatch) => {
  dispatch(getProfileSuccess(null));
  localStorage.clear();
}
